import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { FlexContainer, Pagination } from 'components/common';
import { Box } from 'components/common/box';
import { DateRangeSelector } from 'components/common/charts';
import { LoginHistoryTable } from 'components/common/loginHistory';
import { Filters, FiltersActive } from 'components/common/filter';

const LoginHistory = () => {
  const { messages } = useReduxState();

  const router = useRouter();

  const { data, loading } = useApiData({
    url:
      `/admin/analytics/login-history?` +
      Object.keys(router.query)
        .map((key) => `${key}=${router.query[key]}`)
        .join('&')
  });

  const handleDateRangeChange = ({ fromDate: from, toDate: to }) => {
    const queryParams = { ...router.query };
    if (from) queryParams.fromDate = from;
    else delete queryParams.fromDate;
    if (to) queryParams.toDate = to;
    else delete queryParams.toDate;

    queryParams.page = '1';
    router.replace({ query: queryParams });
  };

  const handlePageChange = ({ page }: { page: number }) => {
    router.replace({ query: { ...router.query, page } });
  };

  const numberOfLoginEntries =
    data?.totalNumberOfLoginEntries && data.totalNumberOfLoginEntries > 10000
      ? '10000+'
      : data?.totalNumberOfLoginEntries || 0;

  return (
    <div>
      <Box
        subHeaderContent={
          <FlexContainer
            style={{
              flexDirection: 'column',
              alignItems: 'flex-start',
              width: '100%'
            }}
          >
            <FlexContainer
              style={{
                gap: '10px 20px',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                width: '100%'
              }}
            >
              <Filters
                filterId="login-history"
                filters={{
                  accountAccess: true,
                  accountIdentifier: true,
                  accountLogin: true,
                  accountType: true,
                  supervisors: true,
                  userAttributes: true,
                  groups: true
                }}
              />

              <DateRangeSelector
                size="header"
                includeAllTimeOption={true}
                updateData={handleDateRangeChange}
              />
            </FlexContainer>

            <FiltersActive filterId="login-history" />
          </FlexContainer>
        }
        loading={loading}
        padding={0}
        title={messages.profileLoginHistory}
        titleCount={numberOfLoginEntries}
      >
        <LoginHistoryTable
          loginEntries={data?.loginEntries}
          userColumn={true}
        />
      </Box>

      <Pagination
        currentPage={router.query.page ? Number(router.query.page) : 1}
        numberOfPages={data?.pages || 1}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default LoginHistory;
